export default "__VITE_ASSET__ClTb_mJw__"